<template>
<div>
    <h1 class="mb-4 text-gray-500">Fansly Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with Fansly downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <fansly-faq></fansly-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Fansly downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Fansly downloader is a software designed to allow users to download content from fansly.com, from posts, profiles and chats for offline viewing.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does fansly downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'The Fansly downloader requires a chrome extension to be installed to find and download the media content associated with the given link.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Can I download media from paid subscription based fansly accounts?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, you can if you are subscribed to the account.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Fansly Downloader - Download Videos & Photos from Fansly',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos and photos from Fansly for free using our Chrome extension. Save content from posts, creator profiles & chats for offline viewing. Works with subscribed accounts.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'fansly downloader, download fansly videos, fansly video downloader, free fansly downloader, fansly chrome extension, fansly bulk download'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/fansly-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>